import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { PageHead, Table, Chip, Modal, Tabs, fmt, when } from "./kit";
import StaffTrack from "./StaffTrack";
import BdReport from "./BdReport";
import kopyalaPano from "../../util/kopyala";

// Bayi sozlesmeleri: kisiye ozel link -> bayi okur, kimlik yukler, WhatsApp'tan kod atar -> burada onaylanir -> imzalar -> PDF.
const SITE = "https://badulive.online/s/";
const WA_HAT = "+971 58 532 4734";

const req = async (path, { method = "GET", body } = {}) => {
  const r = await fetch(`${baseURL}contract/${path}`, {
    method,
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

const indir = async (id, kind, ad) => {
  const r = await fetch(`${baseURL}contract/admin/${id}/file/${kind}`, { headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "" } });
  if (!r.ok) return window.alert("Dosya bulunamadı");
  const b = await r.blob();
  const u = URL.createObjectURL(b);
  const a = document.createElement("a");
  a.href = u;
  a.download = ad;
  if (kind !== "pdf") a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 30000);
};

const DURUM = {
  created: ["wait", "Link hazır · açılmadı"],
  opened: ["wait", "Açtı · okuyor"],
  read: ["wait", "Okudu · kimlik bekleniyor"],
  kimlik: ["wait", "Kimlik yüklendi · WhatsApp kodu bekleniyor"],
  code: ["wait", "WhatsApp kodu gönderdi · ONAY BEKLİYOR"],
  verified: ["ok", "Onaylandı · imza bekleniyor"],
  signed: ["ok", "İmzalandı"],
  cancelled: ["bad", "İptal"],
};

const TUR = { bayi: "Coin Bayi", manager: "Manager", superadmin: "Super Admin", admin: "Admin", aylik: "Aylık MENA (ALBA, Arapça)" };
const bos = { type: "bayi", region: "", fee: "", startDate: "", workDays: "", workHours: "", deduction: "", target: "", salaryUsd: "", bonusUsd: "", minHours: 6, daysPerWeek: 6, birthDate: "", role: "", endDate: "", managerFee: 200, teamCount: 7, teamFee: 100, teamHours: 3, name: "", phone: "", idNo: "", address: "", email: "", ayvoId: "", iban: "", amountUsd: 2000, rate: 7000, nextMinUsd: "", penaltyUsd: "" };
const inp = { width: "100%", padding: "8px 10px", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14 };

const Contracts = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [yeni, setYeni] = useState(false);
  const [f, setF] = useState(bos);
  const [busy, setBusy] = useState(false);
  const [detay, setDetay] = useState(null);

  const load = useCallback(async () => {
    const r = await req("admin/list");
    if (r?.status) setList(r.list);
    setLoading(false);
  }, []);

  useEffect(() => {
    load();
    // bayi WhatsApp kodu gonderince liste kendiliginden yenilensin
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);

  const link = (c) => SITE + c.token;
  const waMesaj = (c) =>
    `Merhaba ${c.name}, AYVO ${(c.type || "bayi") === "bayi" ? "Resmi Bayilik" : TUR[c.type]} Sözleşmeniz hazır.\n\nAşağıdaki bağlantıdan sözleşmeyi okuyup kimlik doğrulaması ve WhatsApp onayıyla imzalayabilirsiniz (7 gün geçerlidir):\n${link(c)}\n\nARDU INTERACTIVE - FZCO`;
  const waAc = (c) => window.open(`https://wa.me/${String(c.phone || "").replace(/\D/g, "")}?text=${encodeURIComponent(waMesaj(c))}`, "_blank");

  const olustur = async () => {
    if (!f.name.trim() || String(f.phone).replace(/\D/g, "").length < 10) return window.alert("Ad ve telefon (ülke koduyla, ör. 90555...) gerekli");
    setBusy(true);
    const r = await req("admin/create", { method: "POST", body: f });
    setBusy(false);
    if (!r?.status) return window.alert(r?.message || "Oluşturulamadı");
    setYeni(false);
    setF(bos);
    await load();
    const c = { ...f, token: r.contract.token };
    if (window.confirm("Sözleşme linki hazır. WhatsApp'ta bayiye göndermek için açılsın mı?")) waAc(c);
  };

  const islem = async (c, yol, soru) => {
    if (soru && !window.confirm(soru)) return;
    const r = await req(`admin/${c._id}/${yol}`, { method: "POST" });
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız");
    load();
  };

  const [filtre, setFiltre] = useState("");
  const [sayfa, setSayfa] = useState("sozlesme");
  const gorunen = list.filter((c) => !filtre || (c.type || "bayi") === filtre);
  const bekleyen = list.filter((c) => c.status === "code" || c.status === "kimlik");

  return (
    <>
      <PageHead
        title="Sözleşmeler"
        sub={`Bayi ve personel (Manager / Super Admin / Admin) · kişiye özel link · kimlik + WhatsApp onayı (${WA_HAT}) · elektronik imza · PDF`}
        right={
          <button className="btn btn-primary" onClick={() => setYeni(true)}>
            + Yeni sözleşme
          </button>
        }
      />

      <Tabs tabs={[["sozlesme", "Sözleşmeler"], ["takip", "Personel takibi"], ["bd", "BD raporu"]]} value={sayfa} onChange={setSayfa} />
      {sayfa === "bd" ? (
        <BdReport />
      ) : sayfa === "takip" ? (
        <StaffTrack />
      ) : (
        <>
      {bekleyen.length > 0 && (
        <div className="card" style={{ border: "2px solid #F59E0B", background: "#FFFBEB" }}>
          <div className="card-body">
            <b>WhatsApp onayı bekleyenler</b>
            <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 8 }}>
              {WA_HAT} hattına <b>bayinin sözleşmedeki kendi numarasından</b> aşağıdaki kod geldiyse “Kod geldi, onayla”ya bas.
            </div>
            {bekleyen.map((c) => (
              <div key={c._id} className="d-flex align-items-center" style={{ gap: 12, padding: "8px 0", borderTop: "1px solid #FDE68A", flexWrap: "wrap" }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <b>{c.name}</b> · +{String(c.phone).replace(/\D/g, "")} · No {c.no}
                </div>
                <div style={{ fontSize: 22, fontWeight: 800, letterSpacing: 4, color: "#4F46E5" }}>{c.code}</div>
                <button className="btn btn-success btn-sm" onClick={() => islem(c, "verify", `${c.name} için WhatsApp'a ${c.code} kodu, +${String(c.phone).replace(/\D/g, "")} numarasından geldi mi?`)}>
                  Kod geldi, onayla
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="d-flex" style={{ gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
        {[["", "Tümü"], ...Object.entries(TUR)].map(([k, l]) => (
          <button key={k} className={`btn btn-sm ${filtre === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setFiltre(k)}>
            {l} ({k ? list.filter((c) => (c.type || "bayi") === k).length : list.length})
          </button>
        ))}
      </div>

      {loading ? (
        <div className="card"><div className="card-body"><div className="badu-empty">Yükleniyor…</div></div></div>
      ) : gorunen.length === 0 ? (
        <div className="card"><div className="card-body"><div className="badu-empty">Henüz sözleşme yok. “+ Yeni sözleşme” ile başla.</div></div></div>
      ) : (
        <div style={{ display: "grid", gap: 10 }}>
          {gorunen.map((c) => {
            const [k, t] = DURUM[c.status] || ["wait", c.status];
            const bitti = c.status !== "signed" && c.expiresAt && new Date(c.expiresAt) < new Date();
            const tur = c.type || "bayi";
            const renk = { bayi: "#F59E0B", manager: "#2563EB", superadmin: "#7C3AED", admin: "#0EA5E9", aylik: "#16A34A" }[tur] || "#6B7280";
            const ozet =
              tur === "bayi"
                ? `${fmt(c.amountUsd)} $ ilk alım · 1$ = ${fmt(c.rate)} coin`
                : tur === "aylik"
                ? "Aylık iş birliği · ALBA GROUP · Arapça"
                : [c.region, c.fee].filter(Boolean).join(" · ");
            const btn = { padding: "4px 10px", fontSize: 12.5 };
            return (
              <div key={c._id} className="card" style={{ margin: 0, borderLeft: `4px solid ${renk}` }}>
                <div className="card-body" style={{ padding: "12px 16px", display: "grid", gridTemplateColumns: "minmax(180px,1.2fr) minmax(200px,2fr) 170px auto", gap: 14, alignItems: "center" }}>
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 11, fontWeight: 800, color: renk, textTransform: "uppercase", letterSpacing: 0.4 }}>
                      {TUR[tur]} · No {c.no}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 15, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{c.name}</div>
                    <div style={{ fontSize: 12, color: "#6B7280" }}>
                      {c.phone ? `+${String(c.phone).replace(/\D/g, "")}` : "telefon yok"}
                      {c.ayvoId ? ` · ID ${c.ayvoId}` : ""}
                    </div>
                  </div>
                  <div title={ozet} style={{ fontSize: 12.5, color: "#374151", lineHeight: 1.45, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", minWidth: 0 }}>
                    {ozet || "—"}
                  </div>
                  <div>
                    {bitti && c.status !== "cancelled" ? <Chip kind="bad">Süresi doldu</Chip> : <Chip kind={k}>{t}</Chip>}
                    <div style={{ fontSize: 11.5, color: "#6B7280", marginTop: 4 }}>{when(c.signedAt || c.createdAt)}</div>
                  </div>
                  <div className="d-flex" style={{ gap: 6, flexWrap: "wrap", justifyContent: "flex-end" }}>
                    {c.status === "signed" ? (
                      <button className="btn btn-primary btn-sm" style={btn} onClick={() => indir(c._id, "pdf", `AYVO-${TUR[tur].replace(/[^A-Za-z0-9]/g, "")}-${c.no}.pdf`)}>
                        PDF indir
                      </button>
                    ) : c.status !== "cancelled" ? (
                      <>
                        <button className="btn btn-success btn-sm" style={btn} onClick={() => waAc(c)}>
                          WhatsApp
                        </button>
                        <button className="btn btn-outline-secondary btn-sm" style={btn} onClick={() => kopyalaPano(link(c)).then((ok) => window.alert(ok ? "Link kopyalandı" : "Kopyalanamadı: " + link(c)))}>
                          Link
                        </button>
                        {bitti && (
                          <button className="btn btn-outline-primary btn-sm" style={btn} onClick={() => islem(c, "extend")}>
                            +7 gün
                          </button>
                        )}
                      </>
                    ) : null}
                    <button className="btn btn-outline-secondary btn-sm" style={btn} onClick={() => setDetay(c)}>
                      Detay
                    </button>
                    {c.status !== "signed" && c.status !== "cancelled" && (
                      <button className="btn btn-outline-danger btn-sm" style={btn} onClick={() => islem(c, "cancel", "Bu sözleşme linki iptal edilsin mi?")}>
                        İptal
                      </button>
                    )}
                    <button
                      className="btn btn-outline-danger btn-sm"
                      style={btn}
                      title="Kalıcı sil"
                      onClick={() =>
                        islem(
                          c,
                          "delete",
                          c.status === "signed"
                            ? `DİKKAT: ${c.name} imzalı sözleşmesi, kimlik fotoğrafları ve PDF'i kalıcı olarak silinecek. Emin misin?`
                            : `${c.name} sözleşmesi ve yüklenen dosyalar kalıcı olarak silinsin mi?`
                        )
                      }
                    >
                      🗑
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

        </>
      )}

      <Modal open={yeni} title="Yeni sözleşme" onClose={() => setYeni(false)}>
        <label style={{ fontSize: 13, fontWeight: 600 }}>Sözleşme türü</label>
        <div className="d-flex" style={{ gap: 6, marginBottom: 12, flexWrap: "wrap" }}>
          {Object.entries(TUR).map(([k, l]) => (
            <button key={k} type="button" className={`btn btn-sm ${f.type === k ? "btn-primary" : "btn-outline-secondary"}`} onClick={() => setF({ ...f, type: k })}>
              {l}
            </button>
          ))}
        </div>
        {[
          ["name", "Ad Soyad / Unvan *"],
          ["phone", "WhatsApp telefonu * (ülke koduyla, ör. 905551112233)"],
          ["idNo", "T.C. Kimlik No / VKN – Vergi Dairesi"],
          ["address", "Adres"],
          ["email", "E-posta"],
          ["ayvoId", f.type === "bayi" ? "AYVO kullanıcı ID" : "AYVO kullanıcı ID * (personel takibi için zorunlu)"],
          ["iban", "IBAN"],
          ...(f.type === "aylik"
            ? [
                ["birthDate", "Doğum tarihi"],
                ["role", "Görev (boşsa: MENA Etkinlik Odası Müdürü)"],
                ["startDate", "Başlangıç tarihi"],
                ["endDate", "Bitiş tarihi"],
              ]
            : f.type !== "bayi"
            ? [
                ["region", "Sorumlu olduğu bölge / dil (ör. Türkiye, Arapça)"],
                ["fee", "Ücret / prim (ör. Aylık 300 USD + bölge gelirinin %2'si)"],
                ["startDate", "Başlangıç tarihi (ör. 20.10.2026)"],
                ["workDays", "Çalışma günleri (boşsa: Haftada 6 gün)"],
                ["workHours", "Çalışma saatleri (ör. Günde 8 saat, 18:00–02:00 TR saati)"],
                ["deduction", "Devamsızlık kesintisi (boşsa: gelinmeyen her gün ücretin 1/30'u, ayda 3+ gün → prim yok)"],
                ["target", "Aylık hedef (ör. 5 yeni ajans, bölge geliri 20.000 USD)"],
              ]
            : []),
        ].map(([k, l]) => (
          <div key={k} style={{ marginBottom: 10 }}>
            <label style={{ fontSize: 13, fontWeight: 600 }}>{l}</label>
            <input style={inp} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
          </div>
        ))}
        <div className="d-flex" style={{ gap: 10, flexWrap: "wrap" }}>
          {(f.type === "aylik"
            ? [
                ["managerFee", "Müdür ücreti (USD)"],
                ["teamCount", "Ekip kişi sayısı"],
                ["teamFee", "Ekip kişi başı (USD)"],
                ["teamHours", "Ekip günlük saat"],
              ]
            : f.type === "bayi"
            ? [
                ["amountUsd", "İlk alım (USD)"],
                ["rate", "1 USD = coin"],
                ["nextMinUsd", "Sonraki asgari (USD)"],
                ["penaltyUsd", "Cezai şart (USD)"],
              ]
            : [
                ["salaryUsd", "Aylık sabit ücret (USD)"],
                ["bonusUsd", "Aylık prim (USD)"],
                ["minHours", "Günlük asgari saat"],
                ["daysPerWeek", "Haftada gün"],
                ["penaltyUsd", "Cezai şart (USD)"],
              ]
          ).map(([k, l]) => (
            <div key={k} style={{ flex: "1 1 30%" }}>
              <label style={{ fontSize: 12, fontWeight: 600 }}>{l}</label>
              <input style={inp} type="number" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} />
            </div>
          ))}
        </div>
        <div style={{ fontSize: 12, color: "#6B7280", margin: "10px 0" }}>
          Bilgiler sözleşmede aynen yazar. Link 7 gün geçerlidir; bayi açınca sözleşmeyi okur, kimliğini yükler, kodu {WA_HAT} hattına WhatsApp'tan gönderir, sen onaylarsın, imzalar.
        </div>
        <button className="btn btn-primary w-100" disabled={busy} onClick={olustur}>
          {busy ? "Oluşturuluyor…" : "Link oluştur"}
        </button>
      </Modal>

      <Modal open={!!detay} title={detay ? `Sözleşme ${detay.no} · ${detay.name}` : ""} onClose={() => setDetay(null)} wide>
        {detay && (
          <div style={{ fontSize: 13 }}>
            <div style={{ marginBottom: 8 }}>
              Link: <code>{link(detay)}</code>
            </div>
            <div className="d-flex" style={{ gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
              {[
                ["idFront", "Kimlik ön"],
                ["idBack", "Kimlik arka"],
                ["selfie", "Selfie"],
                ["pdf", "İmzalı PDF"],
              ].map(([k, l]) =>
                detay.has?.[k] ? (
                  <button key={k} className="btn btn-outline-primary btn-sm" onClick={() => indir(detay._id, k, `${detay.no}-${k}${k === "pdf" ? ".pdf" : ".jpg"}`)}>
                    {l}
                  </button>
                ) : null
              )}
            </div>
            {detay.pdfHash && (
              <div style={{ marginBottom: 8, wordBreak: "break-all" }}>
                PDF SHA-256: <code>{detay.pdfHash}</code>
              </div>
            )}
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Adım</th>
                  <th>Zaman</th>
                  <th>IP</th>
                  <th>Cihaz / not</th>
                </tr>
              </thead>
              <tbody>
                {(detay.events || []).map((e, i) => (
                  <tr key={i}>
                    <td>{e.step}</td>
                    <td>{when(e.at)}</td>
                    <td>{e.ip}</td>
                    <td style={{ fontSize: 11, maxWidth: 320, wordBreak: "break-all" }}>{e.note || e.ua}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Contracts;
